import React, { useEffect, useState } from 'react';

import { useFormik } from 'formik';
import _ from 'lodash';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { register } from 'api/endpoints/auth';
import LayoutMain from 'components/layouts/LayoutMain';
import StepIndicator from 'components/StepIndicator';
import { ENUM_STEP_REGISTER } from 'constants/enum';
import { TEXT_REGISTER } from 'constants/string/texts';
import { toastError, toastSuccess } from 'lib/toast';
import ConfirmAccountInfomation from 'pages/Register/ConfirmAccountInfomation';
import EnterAccountInfomation from 'pages/Register/EnterAccountInfomation';
import AppRoutes from 'routes/routes';
import { setLoading } from 'store/actions/common';
import {
  checkPasswordRegister,
  getCodeJapaneseGovernmentsWith,
  getJapaneseGovernments,
  validateEmail,
  isFullWidth,
  validateJapanese,
} from 'utils/helper';

const Register = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [emailInValidJapan, setEmailInValidJapan] = useState(false);

  const initialValues = {
    step: ENUM_STEP_REGISTER.ENTER_ACCOUNT_INFO,
    email: '',
    password: '',
    passwordConfirm: '',
    municipality: '',
    department: '',
  };

  const form = useFormik({
    initialValues: initialValues,
    validateOnChange: isSubmitted,
    validateOnBlur: false,
    validate: (values) => {
      const errors = {};

      if (values.email && (isFullWidth(values.email) || validateJapanese(values.email))) {
        errors.email = true;
        setEmailInValidJapan(true);
      } else if (!values.email || !validateEmail(values.email)) {
        errors.email = true;
        setEmailInValidJapan(false);
      } else {
        setEmailInValidJapan(false);
      }
      if (!values.password || checkPasswordRegister(values.password).length > 0) errors.password = checkPasswordRegister(values.password);
      if (!values.passwordConfirm || values.password !== values.passwordConfirm) errors.passwordConfirm = true;
      if (!values.municipality) {
        errors.municipality = true;
      } else {
        const japanese_government = getJapaneseGovernments() || [];
        const governmentExits = _.findIndex(japanese_government, (item) => _.some(item.options, { value: values.municipality }));
        if (governmentExits === -1) {
          errors.municipality = true;
        }
      }

      if (!values.department) errors.department = true;

      if (values.step === ENUM_STEP_REGISTER.ENTER_ACCOUNT_INFO) {
        setIsSubmitted(true);
      }

      return errors;
    },
    onSubmit: async (values) => {
      // Next to step confirmation account info
      if (values.step === ENUM_STEP_REGISTER.ENTER_ACCOUNT_INFO) {
        setIsSubmitted(false);
        form.setErrors({});
        form.validateOnChange = false;
        form.setValues({ ...form.values, step: ENUM_STEP_REGISTER.CONFIRM_ACCOUNT_INFO });
      }

      // Handle create register
      if (values.step === ENUM_STEP_REGISTER.CONFIRM_ACCOUNT_INFO) {
        const data = Object.assign({}, values);
        delete data.step;

        try {
          dispatch(setLoading({ isOpen: true }));
          await register({
            ...data,
            municipality: getCodeJapaneseGovernmentsWith(values.municipality, true) || '',
          })
            .then((response) => {
              toastSuccess(response.message);
              navigate(AppRoutes.login);
              form.resetForm();
            })
            .catch((error) => {
              toastError(error.message);
            });
          dispatch(setLoading({ isOpen: false }));
        } catch {
          dispatch(setLoading({ isOpen: false }));
        }
      }
    },
  });

  const onBackToEnterAccount = () => {
    form.setFieldValue('step', ENUM_STEP_REGISTER.ENTER_ACCOUNT_INFO);
    form.setFieldValue('password', '');
    form.setFieldValue('passwordConfirm', '');
    setIsSubmitted(true);
  };

  useEffect(() => {
    // Reset submited
    if (form.values.step === ENUM_STEP_REGISTER.CONFIRM_ACCOUNT_INFO) {
      setIsSubmitted(false);
    }
  }, [form.values]);

  return (
    <LayoutMain className={'min-h-main !py-8'}>
      <section id="register">
        {form.values.step === ENUM_STEP_REGISTER.ENTER_ACCOUNT_INFO && (
          <h2 className="text-center text-xl font-bold text-black-102">{TEXT_REGISTER.TITLE}</h2>
        )}
        {form.values.step === ENUM_STEP_REGISTER.CONFIRM_ACCOUNT_INFO && (
          <h2 className="text-center text-xl font-bold text-black-102">{TEXT_REGISTER.STEP_TEXT_CONFIRM_ACCOUNT_INFO}</h2>
        )}
        <form className="mt-8">
          <StepIndicator
            currentStep={form.values.step}
            numStep={Object.keys(ENUM_STEP_REGISTER).length}
            steps={[
              {
                label: TEXT_REGISTER.STEP_TEXT_ENTER_ACCOUNT_INFO,
                element: <EnterAccountInfomation emailInValidJapan={emailInValidJapan} form={form} />,
              },
              {
                label: TEXT_REGISTER.STEP_TEXT_CONFIRM_ACCOUNT_INFO,
                element: <ConfirmAccountInfomation form={form} back={onBackToEnterAccount} />,
              },
            ]}
          />
        </form>
      </section>
    </LayoutMain>
  );
};

export default React.memo(Register);
